import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { useStaticQuery, graphql } from "gatsby"
import { Select, Input } from "gatsby-theme-gba"

const LocationSelectEditable = ({ blok }) => {
  const defaultLang = process.env.GATSBY_DEFAULT_LANG
    ? process.env.GATSBY_DEFAULT_LANG
    : "de"
  const locationStories = useStaticQuery(graphql`
    query LocationSelectQuery {
      allStoryblokEntry(
        filter: { default_full_slug: { regex: "/^location-preferences/" } }
      ) {
        nodes {
          uuid
          lang
          field_name_string
        }
      }
      fallback: allStoryblokEntry(
        filter: { full_slug: { regex: "/^location-preferences/" } }
      ) {
        nodes {
          uuid
          lang
          field_name_string
        }
      }
    }
  `)

  const filterLang =
    blok.currentLanguage === defaultLang ? "default" : blok.currentLanguage

  let locations = []

  let defaultStories = locationStories.allStoryblokEntry.nodes

  const allStories = defaultStories.length
    ? defaultStories
    : locationStories.fallback.nodes

  for (var i = 0; i < blok.locations.length; i++) {
    let locationItem = blok.locations[i]

    let locationInAllLanguages = allStories.filter(
      (node) => node.uuid === locationItem
    )

    let currentLanguageLocation = locationInAllLanguages.filter(
      (node) => node.lang === filterLang
    )[0]

    let customFallbackLang = "en"

    locationInAllLanguages = locationInAllLanguages.sort(
      (firstEl, secondEl) => {
        if (firstEl.lang === secondEl.lang) {
          return 0
        }
        if (firstEl.lang === customFallbackLang) {
          return -1
        }
        return 0
      }
    )

    let fallbackLocation = locationInAllLanguages[0]

    let location = currentLanguageLocation

    if (!currentLanguageLocation) {
      location = fallbackLocation
    }
    if (location) {
      locations.push({
        value: location.uuid,
        name: location.field_name_string,
      })
    }
  }

  // console.log(blok.locations)
  // const locations = blok.locations.map(location => {
  //   let locationName
  //   location.lang === "default"
  //     ? (locationName = location.name)
  //     : (locationName = location.content.name)
  //   return {
  //     value: location.uuid,
  //     name: locationName,
  //   }
  // })

  if (locations.length > 1) {
    locations.unshift([
      {
        value: "",
        name: "",
      },
    ])
  }

  const locationsFormElement =
    locations.length === 0 ? null : locations.length === 1 ? (
      <Input
        type="hidden"
        label={blok.label}
        name="recipient"
        required={true}
        value={locations[0].value}
      />
    ) : (
      <Select
        name="recipient"
        label={blok.label}
        value={blok.value}
        placeholder={blok.placeholder}
        options={locations}
        required={true}
        flex={blok.flex}
      />
    )

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      {locationsFormElement}
    </div>
  )
}

export default LocationSelectEditable
